<template>
  <div>
    <span class="source_span" v-if="title">{{ title }}</span>
    <el-cascader
      :style="getCascaderStyle()"
      v-model="payWays"
      :placeholder="placeholder"
      :props="cascaderProps"
      collapse-tags
      @change="cascaderChange"
      :options="cascaderOptions"
      :size="size"
    />
  </div>
</template>

<script>
import * as _ from 'lodash';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
    selectOptions: {
      type: Array,
      default: () => ([]),
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    cascaderProps: {
      type: Object,
      default: () => ({
        multiple: true,
        checkStrictly: true,
      }),
    },
    selectList: {
      type: Array,
      default: () => ([]),
    },
    cascaderStyle: {
      type: Object,
      default: () => ({}),
    },
    hasAll: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      payWays: ['all', '-1'],
      shareScopeEnd: [['all', '-1']],
    };
  },
  computed: {
    cascaderOptions() {
      const arr = _.cloneDeep(this.selectOptions || []);
      if (this.hasAll) {
        arr.unshift({
          value: 'all',
          label: '全部',
        });
      }
      return arr;
    },
  },
  methods: {
    getCascaderStyle() {
      return {
        // marginRight: '32px',
        minWidth: '250px',
        ...this.cascaderStyle,
      };
    },
    getSelectValue() {
      const selectWays = [...new Set(this.flattenArr(this.payWays))];
      const payWays = selectWays[0] === 'all' ? [] : selectWays;
      const payWaysArr = payWays.slice(1);
      return {
        childrenSelect: payWaysArr,
        parentSelect: payWays.length > 0 ? payWays[0] : '',
        selectList: payWays,
      };
    },
    cascaderChange(newValue) {
      let changeFlag = false;
      if ((newValue && newValue.length === 0) || newValue.includes('-1')) {
        this.payWays = ['all', '-1'];
        this.shareScopeEnd = [['all', '-1']];
        this.$emit('change', this.getSelectValue());
        return;
      }
      if (newValue && newValue.length !== 0 && this.shareScopeEnd && this.shareScopeEnd.length !== 0) { // 如果值都存在
        // 父子节点无关联
        const father = newValue.map((v) => v[0]);
        if (!father.every((value) => value === this.shareScopeEnd[0][0])) { // 父级改变
          changeFlag = true;
        }
        // 父子节点有关联
        // this.payWays.forEach((item) => {
        //   if (item[0] !== this.shareScopeEnd[0][0]) { // 一级标签不同
        //     changeFlag = true;
        //   } else if ((!item[1] && this.shareScopeEnd[0][1]) || (item[1] && !this.shareScopeEnd[0][1])) {
        //     changeFlag = true;
        //   }
        // });
      }
      if (changeFlag) {
        // 获取变化的父级元素
        newValue = newValue.filter((v) => v[0] !== this.shareScopeEnd[0][0]);
        this.payWays = newValue;
        this.shareScopeEnd = newValue;
        this.$emit('change', this.getSelectValue());
        return;
      }
      this.payWays = newValue;
      this.shareScopeEnd = newValue;
      this.$emit('change', this.getSelectValue());
    },
    // 拓展数组
    flattenArr(arr) {
      while (arr.some((item) => Array.isArray(item))) {
        // 如果当前数组中还有数组，则展开
        arr = [].concat(...arr);
      }
      return arr;
    },
    resetSelect() {
      this.payWays = ['all', '-1'];
      this.shareScopeEnd = [['all', '-1']];
    },
  },
  watch: {
    selectList: {
      deep: true,
      immediate: true,
      handler(list) {
        if (!list || (list && list.length === 0)) {
          this.resetSelect();
        }
      },
    },
  },
};
</script>
